<div
  [id]="configAlert.id"
  role="alert"
  class="alert"
  [class.alert-info]="configAlert.type == genericMessageType.INFO"
  [class.alert-success]="configAlert.type == genericMessageType.SUCCESS"
  [class.alert-warning]="configAlert.type == genericMessageType.WARNING"
  [class.alert-danger]="configAlert.type == genericMessageType.DANGER"
  [ngStyle]="{
    'background-position-y': configAlert.message || configAlert.iconTop ? '20px' : 'center',
    'background-image': configAlert.hideIcon ? 'none' : 'null',
    'padding-left': configAlert.hideIcon ? '1rem' : 'null'
  }"
>
  <div class="container">
    <div
      class="row d-flex"
      [ngClass]="{ 'align-items-center': !configAlert.message }"
    >
      <div
        class="col-11 col-lg-8 me-auto"
        [ngClass]="{
          'col-lg-8': configAlert.hasPositionRight && configAlert.dismissable,
          'col-lg-9': configAlert.hasPositionRight && !configAlert.dismissable,
          'col-lg-11': !configAlert.hasPositionRight && configAlert.dismissable
        }"
      >
        <h4
          *ngIf="configAlert.title"
          class="alert-heading display-5"
          [ngClass]="{ 'm-0': !configAlert.message }"
        >
          {{ configAlert.title! | translate : configAlert.titleArgs }}
        </h4>
        <div
          *ngIf="configAlert.message"
          class="alert-msg"
          [ngClass]="{ 'msg-large': configAlert.messageLarge }"
          [innerHTML]="
            configAlert.message | translate : configAlert.messageArgs
          "
        ></div>
        <hr *ngIf="configAlert.extraInfo" aria-hidden="true" />
        <div *ngIf="configAlert.extraInfo" class="mb-0">
          {{ configAlert.extraInfo! | translate }}
        </div>
      </div>
      <div
        *ngIf="configAlert.hasPositionRight"
        class="col-12 col-lg-3 d-flex justify-content-lg-end align-self-center mt-3 mt-lg-0"
      >
        <ng-content select="[positionRight]"></ng-content>
      </div>
      <div
        class="btn-close-container justify-content-end col-1 d-flex"
        *ngIf="configAlert.dismissable"
      >
        <button
          (click)="closeAlert()"
          class="btn-close button-no-style"
          type="button"
          data-bs-dismiss="alert"
        >
          <svg class="icon close icon-lg" aria-hidden="true">
            <use href="assets/sprite.svg#it-close"></use>
          </svg>
          <span class="visually-hidden">{{ "CLOSE_ALERT" | translate }}</span>
        </button>
      </div>
    </div>
    <div class="row">
      <ng-content select="[positionBottom]"></ng-content>
    </div>
  </div>
</div>
